import { render, staticRenderFns } from "./serenityLinkHouse.vue?vue&type=template&id=4c122cc0"
import script from "./serenityLinkHouse.vue?vue&type=script&lang=js"
export * from "./serenityLinkHouse.vue?vue&type=script&lang=js"
import style0 from "./serenityLinkHouse.vue?vue&type=style&index=0&id=4c122cc0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports